import { render, staticRenderFns } from "./upload-photo.vue?vue&type=template&id=78c8d695&scoped=true&"
import script from "./upload-photo.vue?vue&type=script&lang=js&"
export * from "./upload-photo.vue?vue&type=script&lang=js&"
import style0 from "./upload-photo.vue?vue&type=style&index=0&id=78c8d695&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8d695",
  null
  
)

export default component.exports